import { store } from "../../../..";
import { globalActions } from "../../../../features/global/globalSlice";
import {
    selectSelectedTournament,
    tournamentManagementActions,
} from "../../../../features/tourneymgmt/tournamentManagementSlice";
import { getTemplate, getTournamentSchedule } from "../../../../lib/api";
import { isChildTournament } from "../../../../lib/utils";

const loader = async ({ params }: any) => {
    const tournamentId = parseInt(params.tournamentId);

    store.dispatch(
        tournamentManagementActions.setselectedTournamentId(
            parseInt(params.tournamentId),
        ),
    );

    const fields = store.getState().global.fields;
    const settings = store.getState().global.settings;

    let tournaments = store.getState().tournamentmanagement.tournaments;
    let masterTournaments =
        store.getState().tournamentmanagement.masterTournaments;

    const tournamentsPromise = tournaments.length
        ? Promise.resolve()
        : store.dispatch(tournamentManagementActions.getTournaments());

    const masterTournamentsPromise = masterTournaments.length
        ? Promise.resolve()
        : store.dispatch(tournamentManagementActions.getMasterTournaments());

    const fieldsPromise = fields.length
        ? Promise.resolve()
        : store.dispatch(globalActions.getFields());

    const settingsPromise = settings.length
        ? Promise.resolve()
        : store.dispatch(globalActions.getSettings());

    const [{ schedule }, { template }] = await Promise.all([
        getTournamentSchedule(tournamentId),
        getTemplate("tournament", tournamentId),
        fieldsPromise,
        tournamentsPromise,
        masterTournamentsPromise,
        settingsPromise,
    ]);

    const tournament = selectSelectedTournament(store.getState());

    return {
        schedule,
        header: !isChildTournament(tournament)
            ? `${tournament?.name} - Schedule Actions`
            : "",
        template,
    };
};

export default loader;
